import styled, { keyframes } from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'

const BG_WIDTH = 200
const skeletonAnimation = keyframes`
  0% {
    background-position: ${BG_WIDTH}% 0; // keep aligned to bg size to prevent flickering
  }
  100% {
    background-position: -${BG_WIDTH}% 0;
  }
`

export const LoadingSkeleton = styled.div<{ $width?: number }>`
  width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
  height: 100%;
  background: linear-gradient(
    100deg,
    ${COLORS.fill} 0%,
    ${COLORS.surface} 50%,
    ${COLORS.fill} 100%
  );
  background-size: ${BG_WIDTH}% 100%;
  background-repeat: no-repeat;
  border-radius: ${RADII.field};
  border: 1px solid ${COLORS.fill};
  animation: ${skeletonAnimation} 1.6s infinite linear;
`
